angular.module('core')
  .service('edxStateParamsService', [
    '$state',
    'timeframe', 
    function (
      $state,
      timeframe) {

    // This is a service intended to be used by controllers to extract parameters
    // from the router state or timeframe for use in api calls.  The idea is to help standardize
    // the way parameters are used and reduce the referencing of $state and timeframe from the api
    // layer.

    var self = this;

    // Provide timeframe parameters for early highlights calls used to determine reporting years.
    // Currently just uses the current reporting year.
    self.getTimeframeParamsForEarlyHighlights = function () {
      return {
        sy: timeframe.calculateCurrentReportingYear(),
        untilNow: true
      };
    };
  }]);
